// extracted by mini-css-extract-plugin
module.exports = {"full_width":"richtextcontent_full_width__gaPRN"};